module.exports = __webpack_public_path__ + "media/images/trashCan-35198e5fd68b553afd4f8c2f76dd33ac.svg";